import store from "@/store";
import router from ".";

// 준비중인 플랫폼 페이지
function isNotReadyFlatformCheck(to, from, next) {
    const pageCd = to.params?.pageCd;
    // if(pageCd === 'precisionmedicine') {
    //     alert("준비중입니다.");
    //     router.push(from.href);
    // } else {
        return next();
    //}
}

// 준비중인 컨텐츠 페이지
function isNotReadyContentCheck(to, from, next) {
    const path1 = to.params?.path1;
    const path2 = to.params?.path2;
    if(/* (path1 === 'rnd' && path2 === 'digitalhealthcare') || */ (path1 === 'reserch-institution' && path2 === 'industry')) {
        alert("준비중입니다.");
        router.push(from.href);
    } else {
        return next();
    }
}


export {isNotReadyFlatformCheck, isNotReadyContentCheck};